import { UserSwitchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Modal, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import { authService } from '../components/api'
import { DataEntryParent } from '../components/data-entry-parent'
import { ErrorView } from '../components/show-error'
import useLocalStorage from '../components/useLocalStorage'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const [modal, contextHolder] = Modal.useModal()
  const [externalToken, setExternalToken] = useState('')
  const [passwordlessEmail, setPasswordlessEmail] = useState('')
  const [anotherUserEmail, setAnotherUserEmail] = useState('')
  const [showAnotherUser, setShowAnotherUser] = useState(false)

  const [, setSessionToken] = useLocalStorage('sessionToken')

  const handlePasswordless = () => {
    const email = passwordlessEmail.trim()
    if (!email) {
      modal.warning({ title: 'Email is empty' })
      return
    }
    const anotherEmail = anotherUserEmail.trim()
    authService.externalPasswordless({
        email: email,
        // callbackUrl: window.location.origin,
        ...(anotherEmail ? { anotherUserEmail: anotherEmail } : {}),
      })
      .then(() => {
        modal.info({
          title: 'Passwordless',
          content: 'Login link has been sent to the email',
        })
      })
      .catch((e) => {
        ErrorView(modal, 'externalPasswordless error', e)
      })
  }

  const handleExternalLogin = (tokenArg?: string) => {
    const token = (tokenArg ?? externalToken).trim()
    if (!token) {
      modal.warning({ title: 'Token is empty' })
      return
    }
    authService
      .externalLogin({ token })
      .then((mess) => {
        setSessionToken(mess.sessionId)
        try {
          if (window.location.pathname.startsWith('/login')) {
            window.location.assign('/lab')
          } else {
            window.location.reload()
          }
        } catch (e) {}
      })
      .catch((e) => {
        ErrorView(modal, 'externalLogin error', e)
      })
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token') ?? ''
    if (!token) {
      return
    }
    setExternalToken(token)
    handleExternalLogin(token)
    // Remove the token from the URL so it is not reused or leaked.
    params.delete('token')
    const query = params.toString()
    window.history.replaceState(
      null,
      '',
      window.location.pathname + (query ? `?${query}` : '') + window.location.hash
    )
  }, [])

  return (
    <div style={{ maxWidth: 300, margin: '0 auto', padding: '1rem' }}>
      <h1>Login</h1>
      <DataEntryParent text="Passwordless email">
        <div style={{ display: 'flex', gap: 4 }}>
          <Input
            type="email"
            placeholder="you@example.com"
            value={passwordlessEmail}
            onChange={(e) => setPasswordlessEmail(e.target.value)}
          />
          <Tooltip title="Login as another user">
            <Button
              size="small"
              type={showAnotherUser ? 'primary' : 'text'}
              icon={<UserSwitchOutlined />}
              onClick={() => {
                // Drop the value when hiding so it is not sent unnoticed.
                if (showAnotherUser) {
                  setAnotherUserEmail('')
                }
                setShowAnotherUser(!showAnotherUser)
              }}
            />
          </Tooltip>
        </div>
      </DataEntryParent>
      {showAnotherUser && (
        <DataEntryParent text="As">
          <Input
            type="string"
            // placeholder="another@example.com"
            value={anotherUserEmail}
            onChange={(e) => setAnotherUserEmail(e.target.value)}
          />
        </DataEntryParent>
      )}
      <Button
        type="primary"
        block
        style={{ marginTop: 8 }}
        onClick={handlePasswordless}
      >
        Send login link
      </Button>

      <DataEntryParent text="External token">
        <Input.TextArea
          rows={3}
          placeholder="bo token"
          value={externalToken}
          onChange={(e) => setExternalToken(e.target.value)}
        />
      </DataEntryParent>
      <Button
        type="default"
        block
        style={{ marginTop: 8 }}
        onClick={() => handleExternalLogin()}
      >
        Login with token
      </Button>

      {contextHolder}
    </div>
  )
}
